import { render } from "./RecordsList.vue?vue&type=template&id=1c106ef6&scoped=true"
import script from "./RecordsList.vue?vue&type=script&lang=js"
export * from "./RecordsList.vue?vue&type=script&lang=js"

import "./RecordsList.vue?vue&type=style&index=0&id=1c106ef6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c106ef6"]])

export default __exports__